import { React, useState } from 'react';
import './style.css';

// team members images
import Gevorg from '../../assets/team-members/Gevorg.webp';
import Arman from '../../assets/team-members/Arman.webp';
import Tina from '../../assets/team-members/Tina.webp';
import Lusine from '../../assets/team-members/Lusine.webp';
import Lazaro from '../../assets/team-members/Lazaro.webp';
import Wadsonne from '../../assets/team-members/Wadsonne.webp';
import Patty from '../../assets/team-members/Patty.webp';
import Sofya from '../../assets/team-members/Sofya.webp';

const founders = [
  {
    name: 'Gevorg Shahbazyan',
    position: 'Founder & CEO',
    image: Gevorg,
    description: `Gevorg Shahbazyan is the Founder and CEO of Starlife Group and Companies, a premier real estate development firm based in South Florida. With over a decade of experience in the real estate industry as a developer and broker associate, Gevorg has been instrumental in shaping Miami's real estate landscape. He holds a Master's degree in Global Aairs from Florida International University and is the author of Inside the Mind of a Real Estate Developer, sharing his extensive knowledge and insights. His hands-on involvement in every phase of Starlife's projects has honed his expertise in real estate development and construction.

Under his leadership, Starlife Group has evolved into a thriving organization, comprising Starlife Builders, Starlife Capital Ventures, and Starlife International Realty. The company is actively involved in large-scale multifamily and mixed-use development projects across South Florida, as well as commercial developments in Europe. With a portfolio of over 75 townhomes and a team of professionals with over 55 years of combined experience, Starlife Group has built a solid reputation for excellence and innovation in real estate.`,
  },
  {
    name: 'Arman Shahbazyan',
    position: 'Co-Founder & President',
    image: Arman,
    description: `Arman Shahbazyan is the Co-Founder of Starlife Group and Companies, where he plays a pivotal role in leading the firm's construction and operational activities. With over a decade of experience in real estate, Arman brings a wealth of expertise to his position as a licensed General Contractor in Florida. He is also a licensed Mortgage Broker and Real Estate Agent, enhancing his broad understanding of the industry. A graduate of Florida International University with a Master's in Criminal Justice, Arman has also earned multiple project management and team management certifications from Harvard University. His leadership ensures that every Starlife project is executed with precision and excellence, creating a strong foundation for investor confidence.

As the General Contractor for Starlife Builders, Arman leads a team of Senior Construction Project Managers, VPs of Operations, engineers, superintendents, and other skilled professionals. He oversees Starlife Group's diverse portfolio, including residential, commercial, and mixed-use developments across Florida. Prior to joining Starlife, Arman's leadership at American Airlines gave him invaluable experience in managing large-scale operations involving thousands of employees. His strategic insights and operational expertise make him an essential leader in the growth and success of Starlife's projects, including the EB-5 qualified 21 Hollywood project.`,
  },
];

const team = [
  {
    name: 'Tina Varjabedian',
    position: 'Vice President of Strategy & Development',
    image: Tina,
  },
  {
    name: 'Lusine Shahbazyan',
    position: 'Director of Property & Hospitality Management',
    image: Lusine,
  },
  {
    name: 'Lazaro Monteagudo',
    position: 'Director of Construction',
    image: Lazaro,
  },
  { name: 'Wadsonne Leonel', position: 'Project Manager', image: Wadsonne },
  { name: 'Patty Parrotta', position: 'Project Manager', image: Patty },
  { name: 'Sofya Solodkova', position: 'Office Manager', image: Sofya },
];

export default function TeamMembers() {
  const [selectedFounder, setSelectedFounder] = useState(null);

  const handleFounderClick = (founder) => {
    setSelectedFounder(founder);
  };

  const closeModal = () => {
    setSelectedFounder(null);
  };
  return (
    <div className='team-members-section'>
      <div className='team-members-container'>
        <h2 className='section-title'>Our founders</h2>
        <div className='founders-row'>
          {founders.map((founder, index) => (
            <div
              className='team-card'
              key={index}
              onClick={() => handleFounderClick(founder)}
            >
              <img
                src={founder.image}
                alt={founder.name}
                className='team-image'
              />
            </div>
          ))}
        </div>

        <h2 className='section-title'>Team Members</h2>
        <div className='team-members-row'>
          {team.map((member, index) => (
            <div className='team-card' key={index}>
              <img
                src={member.image}
                alt={member.name}
                className={`team-image ${index === 2 ? 'team-image-full' : ''}`}
              />
              <div className='overlay'>
                <div className='member-info'>
                  <h3>{member.name}</h3>
                  <p>{member.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedFounder && (
        <div className='modal-backdrop' onClick={closeModal}>
          <div className='modal-content' onClick={(e) => e.stopPropagation()}>
            <button className='modal-close' onClick={closeModal}>
              ×
            </button>
            <img
              src={selectedFounder.image}
              alt={selectedFounder.name}
              className='modal-image'
            />
            <h3 className="popup-founder-name">{selectedFounder.name}</h3>
            <p className="popup-founder-position">
              <strong>{selectedFounder.position}</strong>
            </p>
            <p className="popup-founder-description">{selectedFounder.description}</p>
          </div>
        </div>
      )}
    </div>
  );
}
